const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 499.461 499.461",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M388.18,249.731c0,29.257-9.404,56.424-25.078,78.367c-5.224,7.314-11.494,14.629-17.763,20.898 c-22.988,21.943-54.335,36.571-87.771,37.616l0,0c-2.09,0-5.225,0-7.314,0c-2.09,0-5.224,0-7.314,0 c-34.482-2.09-64.784-15.673-88.816-37.616c-6.269-6.269-12.539-13.584-17.763-20.898c-15.673-21.943-25.078-49.11-25.078-78.367 c0-76.278,61.649-137.927,137.927-137.927C326.531,111.804,388.18,173.453,388.18,249.731z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.1961 -0.9806 0.9806 -0.1961 40.5001 438.745)",
    style: {
      fill: "#F8B64C"
    },
    cx: 200.096,
    cy: 202.771,
    rx: 15.674,
    ry: 6.269
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9806 -0.1961 0.1961 -0.9806 554.8722 459.9698)",
    style: {
      fill: "#F8B64C"
    },
    cx: 300.207,
    cy: 202.516,
    rx: 6.269,
    ry: 15.674
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD6E0"
    },
    d: "M364.147,318.694c-5.224,7.314-11.494,14.629-17.763,20.898 c-22.988,21.943-54.335,36.571-87.771,37.616h-14.629c-34.482-2.09-64.784-15.673-88.816-37.616 c-6.269-6.269-12.539-13.584-17.763-20.898c2.09-6.269,5.224-11.494,8.359-15.673c0,0,1.045,0,2.09-1.045l0,0l0,0 c2.09-1.045,6.269-2.09,12.539-5.224c12.539-5.224,30.302-12.539,44.931-20.898c2.09-1.045,5.224-3.135,7.314-4.18 c2.09-1.045,4.18-3.135,6.269-4.18l0,0l2.09-9.404c0,0,8.359,15.673,25.078,18.808c1.045,0,3.135,0,4.18,0h2.09 c2.09,0,4.18,0,6.269,0l0,0c1.045,0,2.09,0,3.135-1.045c1.045,0,2.09-1.045,3.135-1.045c2.09-1.045,3.135-1.045,4.18-2.09 c1.045,0,2.09-1.045,3.135-2.09c2.09-1.045,3.135-2.09,4.18-3.135c2.09-2.09,3.135-3.135,4.18-4.18 c2.09-3.135,3.135-5.224,3.135-5.224l2.09,9.404c19.853,14.629,60.604,30.302,70.008,34.482c1.045,0,2.09,1.045,2.09,1.045 C358.922,307.2,362.057,313.469,364.147,318.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M219.951,296.751l8.359,14.629l11.494-17.763l-3.135-3.135l-9.404,13.584l-10.449-19.853 C217.861,287.347,218.906,291.527,219.951,296.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B64C"
    },
    d: "M281.6,259.135c0,0-8.359,15.673-25.078,18.808c-2.09,0-4.18,0-6.269,0c-2.09,0-4.18,0-6.269,0 c-17.763-2.09-25.078-18.808-25.078-18.808s0-3.135,0-6.269c0-2.09,0-3.135,0-5.224c14.629,17.763,31.347,20.898,31.347,20.898 s16.718-3.135,31.347-20.898c0,1.045,0,3.135,0,5.224C281.6,256,281.6,259.135,281.6,259.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7AF48"
    },
    d: "M281.6,252.865c-14.629,15.673-29.257,18.808-30.302,18.808l0,0l0,0 c-1.045,0-15.673-3.135-30.302-18.808c0-2.09,0-3.135,0-5.224c14.629,17.763,31.347,20.898,31.347,20.898 s16.718-3.135,31.347-20.898C281.6,248.686,280.555,250.776,281.6,252.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M302.498,189.127c0,3.135-1.045,5.224-1.045,5.224c-9.404,67.918-51.2,74.188-51.2,74.188 s-42.841-7.314-51.2-74.188c0,0,0-2.09-1.045-5.224l0,0c-2.09-16.718-4.18-68.963,52.245-67.918 C306.678,120.163,304.588,171.363,302.498,189.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M355.788,304.065l-9.404,36.571c-22.988,21.943-54.335,36.571-87.771,37.616h-7.314V360.49 c1.045-2.09,2.09-4.18,3.135-7.314c2.09-5.224,5.224-10.449,7.314-14.629c0-1.045,1.045-1.045,1.045-2.09 c6.269-11.494,10.449-20.898,10.449-20.898c3.135-7.314,6.269-13.584,7.314-19.853c1.045-2.09,1.045-5.224,2.09-7.314 c3.135-14.629,1.045-21.943,1.045-21.943l0,0c19.853,14.629,60.604,30.302,70.008,34.482L355.788,304.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M280.555,296.751l-8.359,14.629l-11.494-17.763l3.135-3.135l9.404,13.584l10.449-19.853 C282.645,287.347,281.6,291.527,280.555,296.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.478,298.841l6.269,38.661c-4.18,7.314-8.359,16.718-11.494,24.033 c-3.135-7.314-8.359-15.673-11.494-24.033l6.269-38.661l-8.359-9.404l7.314-12.539l0,0c2.09,0,4.18,0,6.269,0c2.09,0,4.18,0,6.269,0 l0,0l7.314,12.539L255.478,298.841z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334A5E"
    },
    d: "M257.567,378.253L257.567,378.253h-7.314c-2.09,0-5.224,0-7.314,0 c-34.482-2.09-64.784-15.673-88.816-37.616l-9.404-36.571l2.09-1.045l0,0l0,0c2.09-1.045,6.269-2.09,12.539-4.18 c12.539-5.224,30.302-12.539,44.931-20.898c2.09-1.045,5.224-3.135,7.314-4.18c2.09-1.045,4.18-3.135,6.269-4.18l0,0 c0,0-2.09,7.314,1.045,21.943c0,2.09,1.045,4.18,2.09,7.314c2.09,5.224,4.18,12.539,7.314,19.853c0,0,5.224,9.404,10.449,20.898 c0,1.045,1.045,1.045,1.045,2.09c2.09,5.224,5.224,10.449,7.314,14.629c1.045,2.09,2.09,5.224,3.135,7.314 C254.433,369.894,257.567,376.163,257.567,378.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334A5E"
    },
    d: "M302.498,189.127l-2.09,2.09c0,0-2.09-27.167-14.629-45.976c0,0-7.314,11.494-35.527,11.494 c-27.167,0-35.527-11.494-35.527-11.494c-12.539,18.808-14.629,45.976-14.629,45.976l-2.09-2.09l0,0 c-2.09-16.718-4.18-68.963,52.245-67.918C306.678,120.163,304.588,171.363,302.498,189.127z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD6E0"
    },
    d: "M460.278,192.261c-5.224-17.763-11.494-34.482-20.898-49.11l17.763-39.706l-59.559-59.559 l-39.706,17.763c-15.673-8.359-32.392-15.673-49.11-20.898L293.094,0h-83.592l-16.718,39.706 c-17.763,5.224-34.482,11.494-49.11,20.898l-39.706-17.763L44.408,102.4l17.763,39.706c-8.359,15.673-15.673,32.392-20.898,49.11 L0.522,206.89v83.592L40.229,307.2c5.224,17.763,11.494,34.482,20.898,49.11l-17.763,39.706l59.559,59.559l39.706-17.763 c15.673,8.359,32.392,15.673,49.11,20.898l15.673,40.751h83.592l15.673-40.751c17.763-5.224,34.482-11.494,49.11-20.898 l39.706,17.763l59.559-59.559L437.29,356.31c8.359-15.673,15.673-32.392,20.898-49.11l40.751-15.673v-83.592L460.278,192.261z  M373.551,373.029c-67.918,67.918-178.678,67.918-247.641,0c-67.918-67.918-67.918-178.678,0-247.641 c67.918-67.918,178.678-67.918,247.641,0C442.514,194.351,442.514,305.11,373.551,373.029z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e3d857492ab9c568b948abbc6fbb760e.svg";
export { ForwardRef as ReactComponent };